<template>
    <div>
        <v-dialog
            v-model="display"
            width="350"
            persistent>
            <v-card flat>
                <v-card-title>{{ $t('print') }}</v-card-title>
                <v-card-text v-if="loading.data">
                    {{ $t('print_msg_quotation') }}
                    <div id="printQuotation" style="display: none" >
                        <div>
                            <div class="row">
                                <div class="col-sm">  
                                    <div>
                                        <h4 class="text-left">Petra Ready Mixed Concrete</h4>
                                        <h4 class="text-left"><b>Quotation</b></h4>
                                        <p class="text-left">khartoum - sudan Industrial Area, Gabra Square.</p>
                                        <p class="text-left"> +249912809360-+249187114000</p>
                                    </div>
                                </div>
                                <div class="col-sm">
                                    <img style="float: right;" class="text-right"  width="150" src="../../assets/petralogo.png" alt="">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm"> 
                                    <div v-if="quotation" class="text-center">
                                        <h3>
                                            <b>{{ this.$t('sales_order_number') }} {{quotation.code}}</b>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div v-if="quotation" class="col-sm">
                                    <h5 class="text-left">{{ $t('title_info') }} :</h5>
                                    <table style="border-collapse: collapse; border: none;" class="table table-bordered table-sm">
                                        <tbody>
                                            <tr>
                                                <th>{{$t('date')}} :</th>
                                                <td>{{ quotation.date }}</td>
                                                <th>{{$t('validity_date')}} : </th>
                                                <td>{{ quotation.validity_date }}</td>
                                            </tr>
                                            <tr>
                                                <th>{{$t('customer_code')}} :</th>
                                                <td>{{ quotation.customer_code }}</td>
                                                <th>{{ $t('customer') }} :</th>
                                                <td>{{ quotation.customer }}</td>
                                                <th>{{ $t('site') }} :</th>
                                                <td>{{ quotation.site }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-if="quotation" class="row">
                                <div class="col-sm">
                                    <table class="table table-bordered table-sm">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>{{ $t('item') }}</th>
                                                <th>{{ $t('quantity') }}</th>
                                                <th>{{ $t('unit_measure') }}</th>
                                                <th>{{ $t('price') }}</th>
                                                <th>{{ $t('total') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(itemLine, index) in quotation.lines" :key="index">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ itemLine.item }}</td>
                                                <td>{{ itemLine.quantity }}</td>
                                                <td>{{ itemLine.measure_unit }}</td>
                                                <td>{{ formatPrice(itemLine.price) }}</td>
                                                <td>{{ formatPrice(itemLine.quantity * itemLine.price) }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="4"></td>
                                                <th>{{ $t('total') }}</th>
                                                <th colspan="4">{{ formatPrice(quotation.total) }}</th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <!-- <br> -->
                            <br>
                            <br>
                            <div class="col-sm text-right">
                                <ol style="direction: rtl;">
                                    <ul>
                                        <li>
                                            <b>
                                            الأسعار أعلاه سارية حتي تاريخ الصلاحية أعلاه.
                                            </b>
                                        </li>
                                    </ul>
                                </ol>
                            </div>
                            <!-- <br>
                            <br>
                            <br> -->
                            <div v-if="quotation"  class="row">
                                <div class="col-sm">
                                    <table class="table table-bordered table-sm">
                                        <tr>
                                            <td>
                                                <h5>Petra RMC: ..................................</h5>
                                                <h5>Signature: ..................................</h5>
                                                <h5>Date: .......................................</h5>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="print" text>
                        {{ $t('print') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('close_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
    </div>
</template>
<script>
import RetryDialog from '@/components/common/RetryDialog';
import { mapActions, mapState } from 'vuex';
import {formatMoney} from 'accounting';
export default {
    name: "QuotationPrintDialog",
    components: {
        RetryDialog
    },
    data() {
        return {
            display: false,
            openParams: null,
            loading: {
                data: true
            }
        }
    },
    computed: {
        ...mapState('sales/quotation', ["quotation"])
    },
    methods: {
        formatPrice(amount) {
            return formatMoney(amount, "SDG ", 2);
        },
        ...mapActions("sales/quotation", ["fetchQuotation"]),
        open(params) {
            this.openParams = params;
            this.loading.data = true;
            this.display = true;
        },
        async openDataFetch() {
            try {
                await this.fetchQuotation(this.openParams.id)
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({message});
            }
        },
        onRetryDialogSubmit(params){
            if(params.target == "openDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
        },
        close() {
            this.display = false;
        },
        print() {
            this.$htmlToPaper("printQuotation");
            this.close();
        }
       
    },
}
</script>